import { CallHistoryModel, PeriodModel } from 'one-card-call-history';
import { Action } from 'one-state';

import {
    SET,
    INIT,
    RUN_REPORT,
    FETCH_REPORT_RESULT,
} from './types';

/**
 * Redux action creator to set the list
 * of Call History
 * @param callHistory list of call history
 * @returns action instance
 */
export const setAction = (callHistory: CallHistoryModel):
    Action<typeof SET, CallHistoryModel> => ({
        type: SET,
        payload: callHistory,
    });


/**
 * action for getting identifier to get report result
 * @returns action instance
 */
export const runReportAction = (period: PeriodModel):
    Action<typeof RUN_REPORT, PeriodModel> => ({
        type: RUN_REPORT,
        payload: period
    });

export const fetchReportResultAction = (identifier: string):
    Action<typeof FETCH_REPORT_RESULT, string> => ({
        type: FETCH_REPORT_RESULT,
        payload: identifier,
    });

/**
 * initialize the state
 * @returns action instance
 */
export const initAction = ():
    Action<typeof INIT> => ({
        type: INIT,
    });

/**
 * List of all valid actions
 */
export type Actions =
    ReturnType<typeof setAction> |
    ReturnType<typeof runReportAction> |
    ReturnType<typeof fetchReportResultAction> |
    ReturnType<typeof initAction>;